import React from "react";

import Lamina18img1 from "../images/lamina18img1.png";
import Lamina18img2 from "../images/lamina18img2.png";
import Lamina18img3 from "../images/lamina18img3.png";
import Lamina18img4 from "../images/lamina18img4.png";
import Lamina18actividad from "../images/lamina18actividad.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";
import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  green: {
    color: theme.palette.green.main,
    borderColor: theme.palette.green.main,
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    "& h1": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
  box: {
    width: 195,
    float: "right",
    marginTop: -140,
  },
  redAct: {
    color: "#ef4136",
    "& p": {
      margin: "1em 1em 0 0",
    },
  },
  redLine: {
    borderBottom: "2px solid #ef4136",
    height: 20,
  },
}));

const Lamina18 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 18: Las distintas formas de ser peruano"
        meta={[
          {
            property: "og:title",
            content: "Lámina 18: Las distintas formas de ser peruano",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Nuestro país está conformado por personas con diferentes características.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="18" color="green" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Title title="Las distintas formas de ser peruano" color="green" />
        <br></br>
        <Actividad color="green" />
        <p>
          <strong>
            Observa las imágenes de algunas personas que viven en nuestro país.
            Luego, responde las preguntas.
          </strong>
        </p>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina18img1} alt="Peruanos" />
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina18img2} alt="Peruanos" />
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina18img3} alt="Peruanos" />
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina18img4} alt="Peruanos" />
            <ul className={classes.box}>
              <li>
                ¿Qué características físicas tiene cada una de estas personas?
              </li>
              <li>¿En qué se parecen?</li>
              <li>¿En qué se diferencian? ¿Por qué?</li>
            </ul>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <TitleSmall
          title="TODAS LAS PERSONAS SOMOS VALIOSAS Y DIFERENTES"
          color="green"
        />
        <p>
          Nuestro país está conformado por personas con diferentes
          características; hay bebés, niñas, niños y jóvenes; adultos y adultos
          mayores. Cada persona es única, con potencialidades y talentos
          valiosos. Además, en el Perú tenemos culturas, formas de vida e
          idiomas diversos. También realizamos actividades diferentes, como
          estudiar, hacer deporte, trabajar, entre otras. Lo que hacemos depende
          de nuestras habilidades, de lo que nos gusta y de las oportunidades
          que tenemos. Vivir todos juntos en el mismo país, siendo tan
          diferentes, es una oportunidad para aprender unos de otros.
        </p>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Actividad color="green" />
            <p>
              <strong>¿Y cómo eres tú?</strong> <br></br>Dibújate. Luego,
              completa tus datos.
            </p>
            <div className={classes.redAct}>
              <p>
                <strong>Nombres:</strong>
              </p>
              <div className={classes.redLine}></div>
              <p>
                <strong>Apellidos:</strong>
              </p>
              <div className={classes.redLine}></div>
              <p>
                <strong>Edad:</strong>
              </p>
              <div className={classes.redLine}></div>
              <p>
                <strong>Menciona 3 rasgos que te caracterizan:</strong>
              </p>
              <div className={classes.redLine}></div>
              <div className={classes.redLine}></div>
              <div className={classes.redLine}></div>
              <p>
                <strong>¿Qué te gusta hacer?</strong>
              </p>
              <div className={classes.redLine}></div>
              <p>
                <strong>¿Qué es lo que haces mejor?</strong>
              </p>
              <div className={classes.redLine}></div>
              <p>
                <strong>¿Cómo te gusta vestir?</strong>
              </p>
              <div className={classes.redLine}></div>
            </div>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina18actividad} alt="Actividad" />
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-18.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.green }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 18: Las distintas formas de ser peruano'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="Emergencias, solidaridad y prevención"
        anteriorEnlace="/lamina-1-17"
        siguiente="En busca de la igualdad de oportunidades"
        siguienteEnlace="/lamina-1-19"
      />
    </>
  );
};

export default Lamina18;
